import React, { useState, useEffect } from "react";

const C = {
  bg: "#0f1a2e",
  bgHeader: "linear-gradient(135deg, #162240 0%, #0f1a2e 100%)",
  text: "#e8dcc8",
  textMuted: "#6b6255",
  gold: "#d4a843",
  goldLight: "#e8c56a",
  border: "#1e3456",
  current: "#e85d4a",
};

const Classic = ({ zmanimList = [], title, showTitle = true, hebrewDate, countdown }) => {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 30000);
    return () => clearInterval(t);
  }, []);

  const dayName = now.toLocaleDateString("he-IL", { weekday: "long" });
  const dateLabel = hebrewDate?.hebrewShort ? `${dayName} ${hebrewDate.hebrewShort}` : dayName;
  const hhmm = `${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;

  return (
    <div style={{
      direction: "rtl", width: "100%", height: "100%",
      backgroundColor: C.bg, overflow: "hidden",
      display: "flex", flexDirection: "column",
      fontFamily: "inherit",
    }}>
      {showTitle && (
        <div style={{
          background: C.bgHeader,
          borderBottom: `3px solid ${C.gold}`,
          padding: "0.9rem 1.5rem",
          display: "flex", flexDirection: "column", alignItems: "center", gap: "4px",
          flexShrink: 0,
          boxShadow: "0 4px 16px rgba(0,0,0,0.4)",
        }}>
          <span style={{ color: C.gold, fontWeight: 700, fontSize: "1.3em", letterSpacing: "1px" }}>{title}</span>
          <span style={{ color: C.text, fontSize: "0.85em", fontWeight: 500, opacity: 0.85 }}>{dateLabel}</span>
          {countdown && (
            <div style={{ display: "flex", alignItems: "center", gap: "6px", marginTop: "2px" }}>
              <span style={{ color: C.text, fontSize: "0.8em" }}>{countdown.label}</span>
              <span style={{ color: C.text, fontSize: "0.75em", opacity: 0.7 }}>{"\u05D1\u05E2\u05D5\u05D3"}</span>
              <span style={{ color: C.current, fontSize: "1em", fontWeight: 700, fontVariantNumeric: "tabular-nums" }}>{countdown.remaining}</span>
            </div>
          )}
        </div>
      )}

      <div style={{ flex: 1, overflow: "auto", padding: "0.8rem 1.2rem" }}>
        {zmanimList.map((item, i) => {
          const toMinAdj = t => { const [h, m] = t.split(":").map(Number); return (h === 0 ? 24 : h) * 60 + m; };
          const isPast = toMinAdj(item.time) < toMinAdj(hhmm);
          const isCurrent = item.time === hhmm;
          return (
            <div key={item.key} style={{
              display: "flex", justifyContent: "space-between", alignItems: "center",
              padding: "0.55rem 0.6rem",
              opacity: isPast ? 0.65 : 1,
              borderBottom: i < zmanimList.length - 1 ? `1px solid ${C.border}50` : "none",
              backgroundColor: isCurrent ? `${C.current}15` : "transparent",
              borderRadius: isCurrent ? "6px" : 0,
            }}>
              <span style={{
                color: isCurrent ? C.current : C.text,
                fontSize: "0.95em", fontWeight: isCurrent ? 700 : 500,
                whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                flex: 1, minWidth: 0,
              }}>{item.label}</span>
              <span style={{
                color: isCurrent ? C.current : C.gold,
                fontSize: "1em", fontWeight: 700,
                fontVariantNumeric: "tabular-nums", flexShrink: 0, marginRight: "12px",
              }}>{item.time}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Classic;
